var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDesign(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 30 30",
    style: {
      enableBackground: "new 0 0 30 30"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 3.7,
    width: 1,
    height: 30
  }), /*#__PURE__*/React.createElement("rect", {
    y: 26.1,
    width: 30,
    height: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26,22.6H8.2c-0.3,0-0.5-0.2-0.5-0.5v-11c0-2.1,1-4,2.8-5.4c1.8-1.4,4.1-2.2,6.6-2.2s4.8,0.8,6.6,2.2 c1.8,1.4,2.8,3.4,2.8,5.4v11C26.5,22.4,26.3,22.6,26,22.6z M8.6,21.6h16.9V11.1c0-3.7-3.8-6.7-8.5-6.7s-8.5,3-8.5,6.7V21.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.8,22.5L16.8,17c-0.2-0.1-0.3-0.4-0.2-0.7c0-0.1,0.1-0.1,0.2-0.2l7.5-4.6H8.2v-1H26c0.3,0,0.5,0.2,0.5,0.5 c0,0.2-0.1,0.3-0.2,0.4L18,16.6l8.3,5.1L25.8,22.5z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.6,
    y: 11.1,
    width: 1,
    height: 11
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesign);
export default __webpack_public_path__ + "static/media/design.5ae983c5c224b22a0d58d796c8c79c3d.svg";
export { ForwardRef as ReactComponent };